import * as tslib_1 from "tslib";
import { EventEmitter, ChangeDetectorRef, OnInit, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { OrderType, ArtemisOrder } from '@artemis-blocks/order';
import { SelectionModel } from '@angular/cdk/collections';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { SearchEngineTypeLabel, SearchEngineTypeValue, SearchType } from 'modules/shared/models/screening.models';
import { AdminService } from 'modules/core/services/admin.service';
import { PusherService } from '../../../../services/pusher.service';
import { AddScreeningResultCommentDialogComponent } from './components/add-screening-result-comment-dialog/add-screening-result-comment-dialog.component';
import { environment } from 'environments/environment';
var SearchesCommon = /** @class */ (function () {
    function SearchesCommon(adminService, cdf, dialog, pusherService, store) {
        this.adminService = adminService;
        this.cdf = cdf;
        this.dialog = dialog;
        this.pusherService = pusherService;
        this.store = store;
        this.matchedChange = new EventEmitter();
        this.screeningCommentChange = new EventEmitter();
        this.refreshAll = new EventEmitter();
        this.refresh = new EventEmitter();
        this.unsubscribe$ = new Subject();
        // Map the key response `-` to `_`
        // For DJ2 only
        this.SEARCH_RESPONSE_KEY_MAP = {
            'address-details': 'address_details',
            'birth-place-details': 'birth_place_details',
            'country-details': 'country_details',
            'date-details': 'date_details',
            'dates-of-birth': 'dates_of_birth',
            'dj-id': 'dj_id',
            'identification-details': 'identification_details',
            'match-type': 'match_type',
            'matched-name': 'matched_name',
            'person-name-details': 'person_name_details',
            'primary-name': 'primary_name',
            'risk-icons': 'risk_icons',
            'state-owned-companies-content': 'state_owned_companies_content',
            'watchlist-content': 'watchlist_content'
        };
        this.orderItems = [
            { value: 'matched', type: OrderType.DESC }
        ];
        this.hasSearch = false;
        this.invalidReason = 'Unknown reason';
        this.isValid = true;
        this.dataSource = new MatTableDataSource();
        this.searchType = SearchType;
        this.isScreeningDone = true;
        this.isFilterOn = true;
        this.updatingMatchStatus = false;
        this.selection = new SelectionModel(true, []);
        this.editingComment = false;
        this.editCommentValue = '';
        this.enableScreeningResultComment = environment['ENABLE_SCREENING_RESULT_COMMENT'];
        this.allowDeleteComment = environment['ALLOW_DELETE_COMMENT'];
    }
    Object.defineProperty(SearchesCommon.prototype, "paginatorContent", {
        set: function (paginator) {
            this.dataSource.paginator = paginator;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchesCommon.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (type) {
            this._type = type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchesCommon.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (data) {
            this._data = data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchesCommon.prototype, "engineLabel", {
        get: function () {
            return this._engineLabel;
        },
        set: function (label) {
            this._engineLabel = label;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchesCommon.prototype, "recordName", {
        get: function () {
            return this._recordName;
        },
        set: function (value) {
            this._recordName = value;
        },
        enumerable: true,
        configurable: true
    });
    SearchesCommon.prototype.ngOnInit = function () {
    };
    SearchesCommon.prototype.ngOnChanges = function (changes) {
        if (changes.data || changes.recordName) {
            this.initBasedOnInputData(this.data);
        }
    };
    SearchesCommon.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    SearchesCommon.prototype.renameKeys = function (keysMap, obj) {
        return Object
            .keys(obj)
            .reduce(function (acc, key) {
            var _a;
            return (tslib_1.__assign({}, acc, (_a = {}, _a[keysMap[key] || key] = obj[key], _a)));
        }, {});
    };
    SearchesCommon.prototype.initDataSource = function (arr, engineType) {
        this.count = arr.length;
        var dataSourceRows = ArtemisOrder.order(arr, this.orderItems).slice(0);
        if (engineType && engineType === SearchEngineTypeValue.INTERNET_SEARCH) {
            this.dataSource.data = this.mapSentimentScoreValue(dataSourceRows);
            this.originalData = this.dataSource.data.slice(0);
        }
        else {
            this.dataSource.data = dataSourceRows;
            this.originalData = this.dataSource.data.slice(0);
        }
        if (this.isFilterOn) {
            this.applyFilter();
        }
        this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
        this.dataSource.sort = this.sortContent;
        this.cdf.detectChanges();
    };
    /**
     * Used to map raw sentiment score to a range from 0 to 1, 1 as most negative
     * @method sortingDataAccessor
     */
    SearchesCommon.prototype.mapSentimentScoreValue = function (dataSourceRows) {
        return dataSourceRows.slice(0)
            .map(function (internetSearchResult) {
            if (internetSearchResult.nlpJson && internetSearchResult.nlpJson.sentiment && internetSearchResult.nlpJson.sentiment.score) {
                var mappedScore = void 0;
                if (internetSearchResult.nlpJson.sentiment.class === 'Negative') {
                    mappedScore = (0.1 - internetSearchResult.nlpJson.sentiment.score) / 1.1;
                }
                else {
                    mappedScore = -(internetSearchResult.nlpJson.sentiment.score + 0.1) / 1.1;
                }
                return tslib_1.__assign({}, internetSearchResult, { nlpJson: tslib_1.__assign({}, internetSearchResult.nlpJson, { sentiment: tslib_1.__assign({}, internetSearchResult.nlpJson.sentiment, { score: mappedScore }) }) });
            }
            else {
                return internetSearchResult;
            }
        });
    };
    /**
     * Apply filter to internet search result, filtering out positive results and those with machted name confidence below 0.6
     * @method applyNlpFilter
     */
    SearchesCommon.prototype.applyFilter = function () {
        if (this.data.engineType === SearchEngineTypeValue.INTERNET_SEARCH) {
            if (this.recordName && this.originalData) {
                this.dataSource.data = this.originalData.filter(function (internetSearchResult) {
                    return !internetSearchResult.isNlpFinished
                        || internetSearchResult.matched
                        || (internetSearchResult.nlpJson
                            && internetSearchResult.nlpJson.sentiment
                            && internetSearchResult.nlpJson.sentiment.class === 'Negative'
                            && internetSearchResult.nlpJson.ner.allNamesHit
                            && internetSearchResult.nlpJson.ner.allNamesHit[0][1] > 0.6);
                });
            }
        }
        this.cdf.detectChanges();
    };
    /**
     * Remove NLP filter
     * @method removeNlpFilter
     */
    SearchesCommon.prototype.removeFilter = function () {
        this.dataSource.data = this.originalData;
    };
    /**
     * Used to sort nested object data
     * @method sortingDataAccessor
     */
    SearchesCommon.prototype.sortingDataAccessor = function (item, property) {
        if (property.includes('.')) {
            return property.split('.')
                .reduce(function (object, key) {
                return object ? object[key] : undefined;
            }, item);
        }
        else {
            return item[property];
        }
    };
    SearchesCommon.prototype.initArr = function (result) {
        var _this = this;
        if (!result) {
            this.hasSearch = false;
            return [];
        }
        this.hasSearch = true;
        this.error = result.error;
        this.isScreeningDone = result.isSearchFinished;
        var arr;
        // FIXME: Later on talked to BE guys use `searchResults` for better clear & consistency code
        arr = result.searchResults ? result.searchResults : result.internetSearchResults;
        // Rename keys apply for DJ2 only
        // Map the key response `-` to `_`
        if (result.engineType === SearchEngineTypeValue.DJ2) {
            // Re-assgin arr
            arr = arr.map(function (a) {
                // Rename keys of search response
                a.searchResponse = _this.renameKeys(_this.SEARCH_RESPONSE_KEY_MAP, a.searchResponse);
                return a;
            });
        }
        return arr;
    };
    SearchesCommon.prototype.initBasedOnInputData = function (data) {
        if (!data) {
            return;
        }
        var arr;
        if (this.isSearch(data)) {
            this._data = data;
            // sort seach results based on createdAt
            this._data.results.sort(function (searchResultA, searchResultB) {
                if (searchResultA.createdAt > searchResultB.createdAt) {
                    return -1;
                }
                else if (searchResultB.createdAt > searchResultA.createdAt) {
                    return 1;
                }
                return 0;
            });
            this.error = data.error;
            // if user is just updating matched status, no need reset to first page
            if (!this.updatingMatchStatus) {
                this.currentPage = 0;
            }
            else {
                this.updatingMatchStatus = false;
            }
            this.isValid = data.results[0] ? data.results[0].valid : true;
            this.invalidReason = data.results[0] ? data.results[0].invalidReason : 'Unknown reason';
            // Init first array if any
            arr = this.initArr(data.results[this.currentPage]);
        }
        else {
            arr = this.initArr(data);
        }
        this._data = data;
        // Init data source
        this.initDataSource(arr, data.engineType);
    };
    SearchesCommon.prototype.isSearch = function (data) {
        return data.count !== undefined;
    };
    SearchesCommon.prototype.selectScreeningHistory = function () {
        this.selection.clear();
        if (this.isSearch(this.data)) {
            var arr = this.initArr(this.data.results[this.currentPage]);
            this.isValid = this.data.results[this.currentPage] ? this.data.results[this.currentPage].valid : true;
            this.invalidReason = this.data.results[this.currentPage] ? this.data.results[this.currentPage].invalidReason : 'Unknown reason';
            this.initDataSource(arr, this.data.engineType);
        }
    };
    /**
     * Turn on or off NLP filter
     * @method toggleNlpFilter
     */
    SearchesCommon.prototype.toggleFilter = function ($event) {
        this.isFilterOn = !this.isFilterOn;
        if (this.isFilterOn) {
            this.applyFilter();
        }
        else {
            this.removeFilter();
        }
        this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
        this.dataSource.sort = this.sortContent;
    };
    /**
     * Whether the number of selected elements matches the total number of rows
     * @method isAllSelected
     */
    SearchesCommon.prototype.isAllSelected = function () {
        return this.selection.selected.length === this.dataSource.data.length;
    };
    /**
     * Selects all rows if they are not all selected; otherwise clear selection
     * @method masterToggle
     */
    SearchesCommon.prototype.masterToggle = function () {
        var _this = this;
        if (this.isAllSelected()) {
            this.selection.clear();
        }
        else {
            this.dataSource.data.forEach(function (row) {
                if (_this.selection && _this.selection.selected
                    && !_this.selection.selected.some(function (selectedId) { return selectedId === row.id; })) {
                    _this.selection.select(row.id);
                }
            });
        }
    };
    /**
     * The label for the checkbox on the passed row
     * @method checkboxLabel
     */
    SearchesCommon.prototype.checkboxLabel = function (row) {
        if (!row) {
            return (this.isAllSelected() ? 'select' : 'deselect') + " all";
        }
        return (this.selection.isSelected(row) ? 'deselect' : 'select') + " row " + (row.position + 1);
    };
    /**
     * Expand or collapse screening result comment
     * @method toggleRow
     */
    SearchesCommon.prototype.toggleRow = function (row) {
        if (this.enableScreeningResultComment && (this.type === this.searchType.SCREENING || this.type === this.searchType.ODD)) {
            this.exitEditCommentMode();
            if (this.expandedElement === row) {
                this.expandedElement = null;
            }
            else {
                this.expandedElement = row;
            }
        }
    };
    /**
     * Show screening result comment input box
     * @method enterEditCommentMode
     */
    SearchesCommon.prototype.enterEditCommentMode = function (row) {
        this.editCommentValue = row.comment.value;
        this.editingComment = true;
    };
    /**
     * Exit screening result comment input box
     * @method exitEditCommentMode
     */
    SearchesCommon.prototype.exitEditCommentMode = function () {
        this.editCommentValue = '';
        this.editingComment = false;
    };
    /**
     * Open the dialog to add comment to multiple screening results
     * @method openAddScreeningResultCommentDialog
     */
    SearchesCommon.prototype.openAddScreeningResultCommentDialog = function () {
        var _this = this;
        this.addScreeningResultCommentDialog = this.dialog.open(AddScreeningResultCommentDialogComponent, {
            autoFocus: false,
            width: '650px'
        });
        this.addScreeningResultCommentDialog.afterClosed()
            .subscribe(function (comment) {
            if (comment) {
                _this.batchSubmitScreeningComment(comment);
            }
        });
    };
    /**
     * Emit event when RE-SCREEN THIS PROFILE button is clicked
     * @method onRefreshAllClicked
     */
    SearchesCommon.prototype.onRefreshAllClicked = function () {
        this.selection.clear();
        this.refreshAll.emit();
    };
    /**
     * Emit event when REFRESH button is clicked
     * @method onRefreshItemClicked
     */
    SearchesCommon.prototype.onRefreshItemClicked = function () {
        this.selection.clear();
        this.refresh.emit();
    };
    /**
     * Mark screening result(s) as matched
     * @method updateMatched
     */
    SearchesCommon.prototype.updateMatched = function () {
        var _this = this;
        var updateToSend = [];
        var selectedData = this.selection.selected.map(function (selectedId) {
            return _this.dataSource.data.find((function (row) { return row.id === selectedId; }));
        });
        selectedData.forEach(function (selectedRow) {
            if (selectedRow.ownNameSearch) {
                updateToSend.push({
                    id: selectedRow.id,
                    matched: true,
                    ownNameSearch: selectedRow.ownNameSearch
                });
            }
            else {
                if (_this._engineLabel.toUpperCase() === 'DOW JONES') {
                    updateToSend.push({
                        id: selectedRow.id,
                        matched: true,
                        engineType: 'DJ3',
                        customerHash: selectedRow.searchResponse.customerHash,
                        matchId: selectedRow.searchResponse.customerDetail.matchId
                    });
                }
                else {
                    updateToSend.push({
                        id: selectedRow.id,
                        matched: true
                    });
                }
            }
        });
        this.screeningCommentChange.emit({
            updateToSend: updateToSend,
            isInternet: !!selectedData[0].internetSearch,
            isOwnName: !!selectedData[0].ownNameSearch
        });
        this.updatingMatchStatus = true;
    };
    /**
     * Remove matched status of screening result(s)
     * @method removeMatchedStatus
     */
    SearchesCommon.prototype.removeMatchedStatus = function (row) {
        if (row.id) {
            var updateToSend = [];
            if (row.ownNameSearch) {
                updateToSend.push({
                    id: row.id,
                    matched: false,
                    ownNameSearch: row.ownNameSearch
                });
            }
            else if (this._engineLabel.toUpperCase() === 'DOW JONES') {
                updateToSend.push({
                    id: row.id,
                    matched: false,
                    engineType: 'DJ3',
                    customerHash: row.searchResponse.customerHash,
                    matchId: row.searchResponse.customerDetail.matchId
                });
            }
            else {
                updateToSend.push({
                    id: row.id,
                    matched: false
                });
            }
            this.screeningCommentChange.emit({
                updateToSend: updateToSend,
                isInternet: !!row.internetSearch,
                isOwnName: !!row.ownNameSearch,
            });
        }
    };
    /**
     * Update screening result comment by batch
     * @method batchSubmitScreeningComment
     */
    SearchesCommon.prototype.batchSubmitScreeningComment = function (commentContent) {
        var _this = this;
        if (!!this.selection.selected.length) {
            var updateToSend_1 = [];
            var selectedData = this.selection.selected.map(function (selectedId) {
                return _this.dataSource.data.find((function (row) { return row.id === selectedId; }));
            });
            selectedData.forEach(function (selectedRow) {
                if (selectedRow.ownNameSearch) {
                    updateToSend_1.push({
                        id: selectedRow.id,
                        comment: {
                            value: commentContent
                        },
                        ownNameSearch: selectedRow.ownNameSearch
                    });
                }
                else {
                    updateToSend_1.push({
                        id: selectedRow.id,
                        comment: {
                            value: commentContent
                        }
                    });
                }
            });
            this.screeningCommentChange.emit({
                updateToSend: updateToSend_1,
                isInternet: !!selectedData[0].internetSearch,
                isOwnName: !!selectedData[0].ownNameSearch
            });
        }
        this.selection.clear();
    };
    /**
     * Update comment of a single screening result
     * @method submitSingleScreeningComment
     */
    SearchesCommon.prototype.submitSingleScreeningComment = function (row) {
        if (row.id) {
            var updateToSend = [];
            if (row.ownNameSearch) {
                updateToSend.push({
                    id: row.id,
                    comment: {
                        value: this.editCommentValue
                    },
                    ownNameSearch: row.ownNameSearch
                });
            }
            else {
                updateToSend.push({
                    id: row.id,
                    comment: {
                        value: this.editCommentValue
                    }
                });
            }
            this.screeningCommentChange.emit({
                updateToSend: updateToSend,
                isInternet: !!row.internetSearch,
                isOwnName: !!row.ownNameSearch
            });
        }
        this.exitEditCommentMode();
    };
    /**
     * Delete comment of a single screening result
     * @method deleteComment
     */
    SearchesCommon.prototype.deleteComment = function (row) {
        if (row.id) {
            var updateToSend = [];
            if (row.ownNameSearch) {
                updateToSend.push({
                    id: row.id,
                    comment: {
                        value: ''
                    },
                    ownNameSearch: row.ownNameSearch
                });
            }
            else {
                updateToSend.push({
                    id: row.id,
                    comment: {
                        value: ''
                    }
                });
            }
            this.screeningCommentChange.emit({
                updateToSend: updateToSend,
                isInternet: !!row.internetSearch,
                isOwnName: !!row.ownNameSearch
            });
        }
        this.exitEditCommentMode();
    };
    return SearchesCommon;
}());
export { SearchesCommon };
